import { Component } from '@angular/core';

@Component({
  selector: 'app-permission-role-user-add',
  templateUrl: './user-add.component.html',
  styleUrls: ['./user-add.component.css']
})
export class UserAddComponent {

}
